import { render } from "./PlanillaDet.vue?vue&type=template&id=351562b5&scoped=true"
import script from "./PlanillaDet.vue?vue&type=script&lang=js"
export * from "./PlanillaDet.vue?vue&type=script&lang=js"

import "./PlanillaDet.vue?vue&type=style&index=0&id=351562b5&scoped=true&lang=css"
import "./PlanillaDet.vue?vue&type=style&index=1&id=351562b5&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351562b5"]])

export default __exports__